/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RemoteStageSummary } from './remoteStageSummary';

export interface RemoteJobSummary {
  remote_id: string;
  name: string;
  status: string;
  stage_count: number;
  stages?: RemoteStageSummary[];
  already_linked?: boolean;
  description?: string | null;
}
